import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ae-general-liability',
  templateUrl: './general-liability.component.html',
  styleUrls: ['./general-liability.component.scss']
})
export class GeneralLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;
  summaryContent;
  constructor() {}

  ngOnInit(): void {
    this.summaryContent = this.summarySitecoreData;
    window.scrollTo(0, 0);
  }
}
